import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NavController,
  NavParams,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { PessoaProvider } from 'src/app/services/pessoa/pessoa';
@Component({
  selector: 'app-pessoa-migrar-grupos',
  templateUrl: './pessoa-migrar-grupos.page.html',
  styleUrls: ['./pessoa-migrar-grupos.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SemRegistroComponent,
    TranslateModule,
    NomenclaturaPipe,
  ],
})
export class PessoaMigrarGruposPage implements OnInit {
  gruposSelect: any = [];
  isVisitante: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController
  ) {
    this.gruposSelect = this.navParams.get('gruposSelect');
    this.isVisitante = this.navParams.get('isVisitante');

    this.gruposSelect.forEach(
      (element: { isVisitante: boolean; selected: boolean }) => {
        element.isVisitante = this.isVisitante ? true : false;
        element.selected = element.selected ? true : false;
      }
    );
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss(this.gruposSelect);
  }

  selecionarGrupos() {
    this.modalCtrl.dismiss(this.gruposSelect);
  }
}
